import type { CatalogTree } from '../types';

// The Merchants list (admin panel screens §3.3): the filter bar, the columns, the states and the
// CSV export. The column headers are also the CSV's header row.
export const merchants = {
  title: 'İşletmeler',
  table: 'İşletme listesi',
  filters: {
    label: 'Filtreler',
    q: 'Ara',
    plan: 'Plan',
    status: 'Durum',
    city: 'Şehir / bölge',
    storeAdapter: 'Mağaza altyapısı',
    channelStatus: 'Kanal durumu',
    usage: 'Yapay zekâ kullanımı',
    usageMin: 'En az birim',
    usageMax: 'En çok birim',
    signup: 'Kayıt tarihi',
    all: 'Tümü',
    clear: 'Filtreleri temizle',
  },
  columns: {
    name: 'İşletme',
    status: 'Durum',
    plan: 'Plan',
    store: 'Mağaza',
    channels: 'Kanallar',
    usage: 'Kullanım',
    signup: 'Kayıt',
    lastActivity: 'Son etkinlik',
  },
  channel: '{flavor}: {status}',
  empty: 'Henüz işletme yok.',
  emptyFiltered: 'Bu filtreye uyan işletme yok.',
  export: {
    button: 'CSV indir',
    tooMany: 'En çok {max} işletme indirilebilir; lütfen filtreyi daraltın.',
  },
} as const satisfies CatalogTree;
